<template>
  <modal :show="show" :show-close="false" class="white-content" @update:show="$emit('update:show', $event)">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="card-title mb-0">{{ title }}</h5>
      <span class="modal-close-icon" @click="$emit('update:show', false)">
        <i class="material-icons">close</i>
      </span>
    </div>
    <div class="row">
      <label for="repair-note-input" class="col-md-12 col-form-label">{{ $t('repairLog.noteLabel') }} *</label>
      <div class="col-12">
        <textarea
          id="repair-note-input"
          ref="noteInput"
          v-model="localNote"
          class="form-control"
          rows="4"
          :placeholder="placeholder"
          maxlength="2000"
        ></textarea>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-sm d-flex justify-content-end">
        <button type="button" class="btn mb-0 btn-dark" @click="handleSubmit">{{ $t('common.submit') }}</button>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from './Modal.vue';

export default {
  components: { Modal },
  props: {
    show: { type: Boolean, required: true },
    title: { type: String, required: true },
    placeholder: { type: String, default: '' },
    initialNote: { type: String, default: '' }
  },
  emits: ['update:show', 'submit'],
  data() {
    return {
      localNote: ''
    };
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.localNote = this.initialNote || '';
        this.$nextTick(() => {
          if (this.$refs.noteInput) {
            this.$refs.noteInput.focus();
          }
        });
      }
    }
  },
  methods: {
    handleSubmit() {
      if (!this.localNote.trim()) {
        this.$toast.info(this.$t('repairLog.noteRequired'), { timeout: 2500 });
        return;
      }
      this.$emit('submit', this.localNote.trim());
    }
  }
};
</script>

<style scoped>
.modal-close-icon {
  cursor: pointer;
}
.modal-close-icon .material-icons {
  font-size: 32px;
  color: var(--primary-color);
}
</style>
